import { gql } from '@apollo/client';

export const SET_SITE_TITLE_IMAGE_MUTATION = gql`
  mutation SetSiteTitleImageMutation(
    $siteId: String!
    $imageId: String
    $cropPosition: SiteImageCropPositionInput
  ) {
    setSiteTitleImage(
      siteId: $siteId
      imageId: $imageId
      cropPosition: $cropPosition
    ) {
      ... on UpdateSiteSuccess {
        site {
          id
          image
          imageCropPosition {
            x
            y
          }
          images
          updatedAt
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
